import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // ✅ 引入 SEO 標籤的 Provider

import NewsPage from './pages/NewsPage';
import SingleNewsPage from './pages/SingleNewsPage';
import DeclarationPage from './pages/DeclarationPage';
import ChartPage from './pages/ChartPage';
import WaroomPage from './pages/WaroomPage';
import InstitutePage from './pages/InstitutePage';
import NotFoundPage from './pages/NotFoundPage';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import UserPage from './pages/UserPage';
import RootLayout from './pages/RootLayout';

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <NewsPage /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/news/:id", element: <SingleNewsPage /> },

      // ✅ 原本的預設圖表頁
      { path: "/chart", element: <ChartPage /> },
      // ✅ SEO 關鍵：新增帶有參數的動態路由，讓每個圖表都有獨立網址
      { path: "/chart/:chartType", element: <ChartPage /> },
      
      { path: "/waroom", element: <WaroomPage /> },
      { path: "/institute", element: <InstitutePage /> },
      { path: "/declaration", element: <DeclarationPage /> },
      { path: "/signup", element: <SignUp /> },
      { path: "/signin", element: <SignIn /> },
      { path: "/dashboard", element: <UserPage /> },
      
      // 404 通配符路由 - 必须放在最后
      { path: "*", element: <NotFoundPage /> },
    ],
    // 可选：为整个 RootLayout 设置错误边界
    errorElement: <NotFoundPage />,
  },
]);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        {/* ✅ 將 RouterProvider 包裹在 HelmetProvider 內，確保全域的 SEO Meta 能被正確寫入 */}
        <HelmetProvider>
            <RouterProvider router={router} />
        </HelmetProvider>
    </React.StrictMode>
);